import { render } from "./AnimeAPI.vue?vue&type=template&id=6d47d9eb&scoped=true"
import script from "./AnimeAPI.vue?vue&type=script&lang=js"
export * from "./AnimeAPI.vue?vue&type=script&lang=js"

import "./AnimeAPI.vue?vue&type=style&index=0&id=6d47d9eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d47d9eb"]])

export default __exports__